var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 2.5a1 1 0 0 1 2 0zm.5.25A4.75 4.75 0 0 0 2.75 7.5v2.75H2a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-.75V7.5A4.75 4.75 0 0 0 8.5 2.75zm2.445 11.366a2.75 2.75 0 0 1-3.89 0l-.085-.086a.75.75 0 0 1 .53-1.28h3a.75.75 0 0 1 .53 1.28z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertFilled);
export default ForwardRef;